export default "__VITE_ASSET__BihmM7Zb__"